export function faqs(state) {
  return state.faqs;
}
